module.exports = __webpack_public_path__ + "img/chip1.d7408764.jpg";